import { ReactElement } from 'react';

import { ASPECT_RATIO_TYPES } from '../../ImageSelector/ImageSelector';

export interface MultiLingualObj {
  en: string;
  ar: string;
}

export interface GenericObject {
  [k: string]: MultiLingualObj | unknown;
}

export interface DataSource {
  source: string;
  rows: GenericObject[];
}

export interface GenericObjectWithActions {
  [k: string]: MultiLingualObj | unknown;
  actions: UserActionsInterface[];
}

export enum ColumnTypes {
  CHECKBOX = 'checkbox',
  TITLE = 'title',
  PILLS = 'pills',
  STATUS = 'status',
  DEFAULT = 'default',
  CUSTOM = 'custom',
  LINK_NEW_BROWSER_TAB = 'link_new_browser_tab',
  LINK_SAME_BROWSER_TAB = 'link_same_browser_tab',
  DATE = 'date',
}

export const CUSTOM_ICON_TYPES = {
  PAUSE: 'PAUSE',
  PUBLISH: 'PUBLISH',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  ACTIVATE: 'ACTIVATE',
  DEACTIVATE: 'DEACTIVATE',
};

export interface ColumnInterface {
  label: string;
  key: string;
  type: ColumnTypes;
  aspectRatio?: ASPECT_RATIO_TYPES;
  publishedKey?: string;
  toggleCheckbox?(row: GenericObject, value: boolean): void;
  sort?(order: string | null): void;
  posStatusChange?(): void;
  isPublished?(row: GenericObject): boolean;
  getNewPublishedStatus?(row: GenericObject): boolean | string;
  getLink?(row: GenericObject): string;
  getImagePath?(row: GenericObject): string;
  format?(row: GenericObject): ReactElement | string;
  customRender?(row: GenericObject): ReactElement;
  validation?(row: GenericObject): boolean;
}

export const ORDER_TYPES = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC',
};

export interface ActionInterface {
  id: string;
  label: string;
  icon(row: GenericObject): string;
  action(row: GenericObject): void;
}

export interface UserActionsInterface {
  id: string;
  label?: string;
  icon: unknown;
  action(row: GenericObject): void;
}

export interface DeleteConfirmation {
  deletable: boolean;
  message?: string;
}
